import React, { useState } from "react";
import { Button, Typography } from "antd";
import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import { features } from "../../data/data";
import "./Features.scss";
import ModelViewer from "../../../landingPage/sectionTwo/modelViewer";
import { buildRegisterUrl } from "../../../../utils/registerRedirect";

const { Title, Paragraph } = Typography;

const Features = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=collaboration`;


  return (
    <div className="feature-sections">
      <div className="feature-sections__container">
        <div className="manrope feature-sections__header manrope f-16 lh-24 w-700">About Our Services</div>
        <div className="manrope feature-sections__title">
          Everything your team needs to bring your PDP to life
        </div>

        <div className="manrope feature-sections__description">
          Our platform offers end-to-end services to help your team create,
          manage, share, and collaborate on all your PDP assets.
        </div>
      </div>

      {features.map((section, index) => (
        <div
          key={index}
          className={`feature-section 
          ${!isExpanded && index === 1 ? "feature-section--hidden" : ""} 
          ${!isExpanded && index >= 2 ? "feature-section__hidden" : ""} 
          ${index % 2 === 0 ? "feature-section--even" : "feature-section--odd"
            }`}
        >
          <div className="feature-section__content">
            <div className="feature-section__header">


              <div
                className={`feature-section__image-container ${index % 2 === 0 ? "left" : "right"
                  }`}
              >
                {section.model ?
                  <div className="feature-section__model-container">
                    <ModelViewer class='feature-section__model'
                      poster={section.poster}
                      src={section.src}
                    />
                  </div>
                  :
                  <img
                    src={section.image}
                    alt={section.title}
                    className={`feature-section__image ${section.no_border ? "no-border" : ""}`}
                  />}
              </div>
              <div className="show-on-mobile feature-section__info" style={{ order: 2 }}>
                <h1 level={2} className="feature-section__title manrope f-24 w-700 lh-32 text-left black-00">
                  {section.title}
                </h1>
                <Paragraph className="feature-section__description manrope f-14 w-500 lh-22">
                  {section.description}
                </Paragraph>
              </div>
              <div className="show-on-desktop feature-section__info">
                <h1 level={2} className="feature-section__title manrope f-24 w-700 lh-32 text-left black-00">
                  {section.title}
                </h1>
                <Paragraph className="feature-section__description manrope f-14 w-500 lh-22">
                  {section.description}
                </Paragraph>
              </div>

            </div>

            <div className="feature-section__list">
              {/* Desktop Table */}
              <table className="desktop-table">
                <tbody>
                  {section.featuresList.map((feature, index) => (
                    <tr key={index}>
                      <td className="feature-check-row">
                        <div
                          className={`feature-check ${feature.isAdd ? "add-icon" : ""
                            }`}
                        >
                          {feature.isAdd ? <PlusOutlined /> : <CheckOutlined />}
                        </div>
                      </td>
                      <td className="title manrope f-14 w-700 lh-22 black-085">{feature.title}</td>
                      <td className="description manrope f-14 lh-22 w-500 black-085">{feature.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Mobile Table */}

              <table className="mobile-table">
                <tbody>
                  {section.featuresList.map((feature, index) => (
                    <tr key={index} className="mobile-feature">
                      <div className="mobile-feature-row">
                        <div
                          className={`feature-check ${feature.isAdd ? "add-icon" : ""
                            }`}
                        >
                          {feature.isAdd ? <PlusOutlined /> : <CheckOutlined />}
                        </div>
                        <div className="title manrope f-14 w-700 lh-22 black-085">{feature.title}</div>
                      </div>
                      <div className="mob-description manrope f-14 lh-22 w-500 black-085">
                        {feature.description}
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}

      {!isExpanded && (
        <div className="feature-section__gradient">
          <Button data-attr="features-reveal-all" onClick={() => setIsExpanded(true)} className="manrope f-16 w-700 lh-24 blue-button">
            Reveal All Services
          </Button>
        </div>
      )}

      <div className="get-started">
        {isExpanded && (
          <Button
            data-attr="features-start-free-trial"
            className="manrope f-16 w-700 lh-24 blue-button"
            onClick={() => window.open(buildRegisterUrl(redirectPath), "_blank")}
          >
            Start your free trial
          </Button>
        )}
      </div>
    </div>
  );
};

export default Features;
